import { useQuery } from '@tanstack/react-query';

export function useSystemLanguage() {
  const query = useQuery({
    queryKey: ['SYSTEM_LANGUAGE'],
    async queryFn() {
      if (RUNTIME_ENV === 'native') {
        const capacitor = await import('@capacitor/device');
        const langCode = await capacitor.Device.getLanguageCode();
        return langCode.value;
      }
      return navigator.language;
    },
  });
  if (query.status === 'success') {
    return {
      status: query.status,
      lang: query.data,
    };
  }
  return {
    status: query.status,
  };
}
